import { callServer, HttpMethod } from "store/utils/client";

const RESOURCE_PATH = "app-inference-configuration";

/** Wire shape returned by the App Inference Configuration endpoints. Mirrors `AppInferenceConfigurationDto` on the server. */
export type AppInferenceConfigurationDto = {
  configured: boolean;
  preferredIntegrationId: string | null;
  updatedBy: string | null;
  updated: string | null;
};

export function getAppInferenceConfiguration(organizationId: string) {
  return callServer<AppInferenceConfigurationDto>({
    method: HttpMethod.Get,
    url: `v1/organizations/${organizationId}/${RESOURCE_PATH}`,
  });
}

export function putAppInferenceConfiguration(
  organizationId: string,
  preferredIntegrationId: string,
) {
  return callServer<AppInferenceConfigurationDto>({
    method: HttpMethod.Put,
    url: `v1/organizations/${organizationId}/${RESOURCE_PATH}`,
    body: {
      preferredIntegrationId,
    },
  });
}

export function clearAppInferenceConfiguration(organizationId: string) {
  return callServer<AppInferenceConfigurationDto>({
    method: HttpMethod.Delete,
    url: `v1/organizations/${organizationId}/${RESOURCE_PATH}`,
  });
}
